import React, {createRef, useState, useEffect} from 'react';
import {reduxForm } from "redux-form";
import {useDispatch, useSelector} from "react-redux";
import { push } from '@lagunovsky/redux-react-router';
import {StickyContainer} from "react-sticky";
import dotProp from 'dot-prop-immutable';

import SubHeader from "../Document_v2/Form/SubHeader";
import Signature from "./Signature";
import ReviewValues from "./ReviewValues";
import FileUploader from "./FileUploader";
import * as actionTypes from '../../store/actions/actionTypes';
import * as reviewActions from '../../store/actions/review';
import ProgressPanelDesktop from "../Document_v2/ProgressPanel/ProgressPanelDesktop";

const Review = ({handleSubmit}) => {
    const [subTitle, setSubTitle] = useState('');
    const dispatch = useDispatch();
    const documentProcessing = useSelector(state => state.main.documentProcessing);
    const {admissionType, sigPadFilled, admissionDocumentType, files, documentHash, multiSign} = useSelector(state => state.review);
    const reduxForm = useSelector(state => state.form);

    const formSubmitHandler = values => {
        // the signature is reused from a previously signed document, so there is nothing to validate here
        if (multiSign) {
            doSubmit(values);
            return;
        }

        let valid = true;
        if (!sigPadFilled) {
            valid = false;
            dispatch({type: actionTypes.REVIEW_ADD_ERROR, error: '_signature'});
        }
        if (admissionDocumentType.signature_relationship_enable) {
            const signerRelation = dotProp.get(reduxForm ,"review.values._signer_relation")
            console.log('signerRelation', signerRelation);
            if (!signerRelation) {
                valid = false;
                dispatch({type: actionTypes.REVIEW_ADD_ERROR, error: '_signatureName'});
            } else if (signerRelation === 'other') {
                const signerRelationHCF = dotProp.get(reduxForm ,"review.values._signer_relation_hcf")
                const signerRelationName = dotProp.get(reduxForm ,"review.values._signatureName")
                if (!signerRelationHCF) {
                    valid = false;
                    dispatch({type: actionTypes.REVIEW_ADD_ERROR, error: '_signer_relation_hcf'});
                }
                if (!signerRelationName) {
                    valid = false;
                    dispatch({type: actionTypes.REVIEW_ADD_ERROR, error: '_signatureName'});
                }
            }
        } else {
            if (!reduxForm || !reduxForm.review || !reduxForm.review.values || !reduxForm.review.values._signatureName) {
                valid = false;
                dispatch({type: actionTypes.REVIEW_ADD_ERROR, error: '_signatureName'});
            }
        }

        if (valid) {
            doSubmit(values);
        }
    }

    const doSubmit = async (values) => {
        if (multiSign) {
            // the Signature component is not rendered, the backend injects the previous signature
            values._multisign = true;
        } else {
            values._signature = sigPadRef.current.getTrimmedCanvas().toDataURL('image/png');
        }
        dispatch(reviewActions.sign(values));
    };

    let sigPadRef = createRef();

    return (
        <main id="main" className="pt-0">
            <section className="setps-block container">
                <StickyContainer>
                    <SubHeader subTitle={subTitle} step={admissionType.steps.length + 1} title="Review" customSave={() => dispatch(push('/'))}/>
                    <form autoComplete="off" className="row step-form" onSubmit={handleSubmit(formSubmitHandler)}>
                        <div className="col-12 col-md-8 col-lg-9 content">
                            <ReviewValues setSubTitle={setSubTitle}/>
                            {admissionDocumentType.fileUploading_enable && <FileUploader files={files} documentHash={documentHash} admissionDocumentType={admissionDocumentType} />}
                            {!multiSign && <Signature ref={sigPadRef} signature_relationship_enable={admissionDocumentType.signature_relationship_enable} signature_relationship={admissionDocumentType.signature_relationship}/>}
                            <div className="btn-holder">
                                <button className="btn btn-primary btn-lg" type="submit" disabled={documentProcessing}>{multiSign ? 'Confirm' : 'Submit'}</button>
                            </div>
                        </div>
                        <ProgressPanelDesktop/>
                    </form>
                </StickyContainer>
            </section>
        </main>
    );
};

export default reduxForm ({
    form: 'review',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
}) (Review);